<template>
  <!-- 返洗订单弹出框 -->
  <div class="wash-order">
    <el-dialog
      title="返洗订单"
      class="wash-dialog"
      :visible.sync="dialogVisible"
      width="45%"
      center
      @close="$emit('update:visible', false)"
    >
      <div class="wash-form">
        <el-form
          style="width:45%"
          :model="washOrderModel"
          ref="washOrderRef"
          label-width="90px"
          size="small"
          :rules="rules"
        >
          <el-form-item label="预约时间:" prop="beginTime">
            <el-date-picker
              v-model="washOrderModel.beginTime"
              :picker-options="pickerOptions1"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择上门取件日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="寄出姓名:">
            <el-input v-model="washOrderModel.senderName"></el-input>
          </el-form-item>
          <el-form-item label="寄出电话:">
            <el-input v-model="washOrderModel.senderPhone"></el-input>
          </el-form-item>
          <el-form-item label="寄出地址:">
            <el-cascader
              v-model="selectedOptionsSender"
              :options="optionsSender"
              placeholder="省/市/区"
              @change="addressChooseSender"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址:">
            <el-input v-model="washOrderModel.senderDetailAddr" type="textarea" rows="3"></el-input>
          </el-form-item>
        </el-form>
        <el-form
          :model="washOrderModel"
          ref="washOrderRef"
          label-width="90px"
          size="small"
          status-icon
          style="width:45%"
        >
          <el-form-item label="订单备注:">
            <el-input v-model="washOrderModel.note" type="textarea" rows="1"></el-input>
          </el-form-item>
          <el-form-item label="寄回姓名:">
            <el-input v-model="washOrderModel.receiverName"></el-input>
          </el-form-item>
          <el-form-item label="寄回电话:">
            <el-input v-model="washOrderModel.receiverPhone"></el-input>
          </el-form-item>
          <el-form-item label="寄回地址:">
            <el-cascader
              v-model="selectedOptionsReceiver"
              :options="optionsReceiver"
              placeholder="省/市/区"
              @change="addressChooseReceiver"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址:">
            <el-input v-model="washOrderModel.receiverDetailAddr" type="textarea" rows="3"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="clothin-list">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="250px"
          ref="multipleTable"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="washingCode" label="水洗码" width="150"></el-table-column>
          <el-table-column prop="productName" label="衣物名称"></el-table-column>
          <el-table-column label="衣物图片">
            <template slot-scope="scope">
              <img
                width="80px"
                height="60px"
                :style="scope.row.productPic?'display:block':'display:none'"
                :src="scope.row.productPic"
              />
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag type="info" v-if="scope.row.status == '0'">未入厂</el-tag>
              <el-tag type="primary" v-if="scope.row.status == '1'">已入厂</el-tag>
              <el-tag type="warning" v-else-if="scope.row.status == '2'">已分检</el-tag>
              <el-tag type="success" v-else-if="scope.row.status == '3'">已总检</el-tag>
              <el-tag type="success" v-else-if="scope.row.status == '4'">已出厂</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="子项" width="180">
            <template slot-scope="scope">
              <p>瑕疵：{{ scope.row.productFlaw }}</p>
            </template>
          </el-table-column>-->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogWashOrder" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 订单返洗
import { insertBackOrder } from "@/api/order.js";
// 衣物修改
import { updateOrderItem } from "@/api/product.js";
// 省市区
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
const defaultWashOrder = {
  backChildDeliverySn: "", //寄回物流子单号
  backDeliveryCompany: null, //寄回物流1:顺丰，2：京东
  backDeliverySn: "", //寄回物流母单
  backOrderSn: "", //发回订单编号
  backStatus: 1, //返洗单标识；0-》正常，1为返洗单
  beginTime: "", //预约开始时间
  bookStatus: null, //预约状态：1失败；2快递下单成功；3美团确认成功
  channelName: "", //渠道来源
  channelOrderId: "", //渠道订单编号
  channelProductId: null, //渠道商品id
  childDeliverySn: "", //物流子单号
  createTime: "", //创建时间
  deliveryCompany: null, //寄出物流
  deliverySn: "", //物流母单号
  deliveryType: 1, //物流类型1-寄出；2-寄回
  diffAmount: 0, //差价
  factoryCity: "", //工厂城市
  factoryDetailAddr: "", //工厂详细地址
  factoryId: 0, //工厂ID
  factoryName: "", //工厂名称
  factoryPhone: "", //工厂电话
  factoryPostCode: "", //工厂邮编
  factoryProvince: "string",
  factoryRegion: "string",
  grillage: "string",
  grillageId: 0,
  id: 0,
  isDelete: 0,
  memberId: 0,
  memberUsername: "string",
  modifyTime: "string",
  note: "string",
  openShopUuid: "string",
  orderSn: "string",
  originalAmount: 0,
  parentOrderSn: "string",
  payAmount: 0,
  payTime: "string",
  payType: 0,
  productId: 0,
  productName: "string",
  quantity: 0,
  receiverCity: "string",
  receiverDetailAddr: "string",
  receiverName: "string",
  receiverPhone: "string",
  receiverPostCode: "string",
  receiverProvince: "string",
  receiverRegion: "string",
  receiverTime: "string",
  sealNum: "string",
  senderCity: "string",
  senderDetailAddr: "string",
  senderName: "string",
  senderPhone: "string",
  senderPostCode: "string",
  senderProvince: "string",
  senderRegion: "string",
  senderTime: "string",
  status: 0
};
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 原订单对象
    orderWash: {
      type: Object,
      default: () => ({})
    },
    // 衣物列表
    clothData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      // 回显数据
      washOrderModel: {},
      // 衣物数据
      tableData: [],
      //日期选择器配置
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // 寄出保存地区级联选择器已选择的数据
      selectedOptionsSender: [],
      optionsSender: regionData,
      // 寄回保存地区级联选择器已选择的数据
      selectedOptionsReceiver: [],
      optionsReceiver: regionData,
      // 表单规则
      rules: {
        beginTime: [
          { required: true, message: "请选择预约时间", trigger: "blur" }
        ]
      },
      // 表格多选数据
      multipleSelection: []
    };
  },
  watch: {
    visible(newValue) {
      this.dialogVisible = newValue;
      console.log("cloth", this.clothData);
      let data = JSON.parse(JSON.stringify(this.orderWash));
      this.washOrderModel = data;
      this.tableData = this.clothData;
      this.washOrderModel.beginTime = "";
      this.washOrderModel.id = null;
      this.washOrderModel.backDeliverySn = "";
      // 实付金额为0
      this.washOrderModel.payAmount = 0;
      // 寄出地址回显
      let arrSender = [];
      arrSender.push(TextToCode[this.washOrderModel.senderProvince].code);
      arrSender.push(
        TextToCode[this.washOrderModel.senderProvince][
          this.washOrderModel.senderCity
        ].code
      );
      // console.log("子", newValue);
      arrSender.push(
        TextToCode[this.washOrderModel.senderProvince][
          this.washOrderModel.senderCity
        ][this.washOrderModel.senderRegion].code
      );
      this.selectedOptionsSender = arrSender;
      // 寄回地址回显
      let arr = [];
      arr.push(TextToCode[this.washOrderModel.receiverProvince].code);
      arr.push(
        TextToCode[this.washOrderModel.receiverProvince][
          this.washOrderModel.receiverCity
        ].code
      );
      arr.push(
        TextToCode[this.washOrderModel.receiverProvince][
          this.washOrderModel.receiverCity
        ][this.washOrderModel.receiverRegion].code
      );
      this.selectedOptionsReceiver = arr;
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 确定按钮
    handleDialogWashOrder() {
      // 获取多选的返洗衣物数量且修改原订单被选择的衣物子项返洗字段
      let arr = this.multipleSelection;
      this.washOrderModel.itemQuantity = arr.length;
      this.washOrderModel.itemRealityQuantity = arr.length;
      if (arr.length != 0) {
        // 返洗订单接口
        insertBackOrder(this.washOrderModel)
          .then(res => {
            if (res.data.code === 200) {
              //返洗单成功后修改原订单子项
              this.$message.success("新增返洗订单成功!");
              this.dialogVisible = false;
              arr.forEach(item => {
                item.washingBack = 1;
                delete item["omsOrderItemDetails"];
                console.log("arr返洗单修改子项", item);
                updateOrderItem(item).then(res => {});
              });
            }
          })
          .catch(() => {});
      }
      console.log("返洗订单", arr);
    },
    // 衣物表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 寄出地区三级级选择器
    addressChooseSender(value) {
      //我们选择地址后，selectedOptions 会保存对应的区域码，例如北京的区域码为'110000'
      //我们要取出区域码对应的汉字，就需要用CodeToText(区域码)进行输出
      this.washOrderModel.senderProvince = CodeToText[value[0]];
      this.washOrderModel.senderCity = CodeToText[value[1]];
      this.washOrderModel.senderRegion = CodeToText[value[2]];
    },
    // 寄回地区三级级选择器
    addressChooseReceiver(value) {
      //我们选择地址后，selectedOptions 会保存对应的区域码，例如北京的区域码为'110000'
      //我们要取出区域码对应的汉字，就需要用CodeToText(区域码)进行输出
      this.washOrderModel.receiverProvince = CodeToText[value[0]];
      this.washOrderModel.receiverCity = CodeToText[value[1]];
      this.washOrderModel.receiverRegion = CodeToText[value[2]];
    }
  }
};
</script>

<style scoped lang="less">
.wash-order {
  /deep/ .el-dialog {
    .el-dialog__body {
      // display: flex;
      padding: 10px 25px 0;
      .wash-form {
        display: flex;
      }
      .el-input__inner {
        width: 198px;
      }
    }
    .el-dialog__footer {
      padding: 20px;
    }
  }
}
</style>
